/**
 * Client-side visitor tracking — respects the cookie consent banner.
 * Only fires when the user has clicked "Accept all" or explicitly opted into
 * analytics.  Emits a POST /api/track/visit on every route change.
 */
const STORAGE_KEY = "careco24.visitor.v1";
const CONSENT_KEY = "careco24.cookie_consent.v1";
const API = process.env.REACT_APP_BACKEND_URL;

function analyticsAllowed() {
    try {
        const raw = localStorage.getItem(CONSENT_KEY);
        if (!raw) return false;
        return JSON.parse(raw).analytics === true;
    } catch { return false; }
}

function uid() {
    if (typeof crypto !== "undefined" && crypto.randomUUID) return crypto.randomUUID();
    return "v_" + Math.random().toString(36).slice(2, 10) + Math.random().toString(36).slice(2, 10);
}

function getVisitorId() {
    try {
        const existing = localStorage.getItem(STORAGE_KEY);
        if (existing) return existing;
        const fresh = uid();
        localStorage.setItem(STORAGE_KEY, fresh);
        // Also mirror into a first-party cookie for downstream analytics
        document.cookie = `${STORAGE_KEY}=${fresh}; max-age=${60 * 60 * 24 * 90}; path=/; SameSite=Lax`;
        return fresh;
    } catch { return uid(); }
}

function readUtm() {
    try {
        const q = new URLSearchParams(window.location.search);
        return {
            utm_source: q.get("utm_source") || undefined,
            utm_medium: q.get("utm_medium") || undefined,
            utm_campaign: q.get("utm_campaign") || undefined,
        };
    } catch { return {}; }
}

export function trackPageview(path) {
    if (!analyticsAllowed()) return;
    try {
        const body = {
            visitor_id: getVisitorId(),
            path: path || window.location.pathname,
            referrer: document.referrer || undefined,
            ...readUtm(),
        };
        fetch(`${API}/api/track/visit`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(body),
            keepalive: true,
        }).catch(() => { /* fire-and-forget */ });
    } catch { /* ignore */ }
}

export async function captureVisitorEmail(email, intent) {
    if (!analyticsAllowed()) return { skipped: "no_consent" };
    try {
        const r = await fetch(`${API}/api/track/capture-email`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                visitor_id: getVisitorId(),
                email,
                intent,
            }),
        });
        return await r.json();
    } catch (e) {
        return { error: e.message };
    }
}
